// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCjegd-DVSUupWzKdmqdmKxItOx45elUbw",
  authDomain: "miles2go-31c02.firebaseapp.com",
  projectId: "miles2go-31c02",
  storageBucket: "miles2go-31c02.firebasestorage.app",
  messagingSenderId: "414889992494",
  appId: "1:414889992494:web:c957f1941b24fca7121abf",
  measurementId: "G-BWJDR3SH32"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Optional: initialize analytics (web only)
const analytics = getAnalytics(app);

// ✅ Initialize and export auth and app
const auth = getAuth(app);

const db = getFirestore(app);

export { app, auth, db };
